import axios from "axios";
import swal from "../utils/swal";
import {baseurl} from "../utils/constants";
import {toggleLoader} from "../utils/helper";

const http = axios.create({
    baseURL: baseurl,
});

const globalLoaderToggle = () => {
    toggleLoader("global-loader");
}
http.interceptors.request.use(config => {
    globalLoaderToggle();
    return config;
});
http.interceptors.response.use(response => {
        globalLoaderToggle();
        return response;
    }
    , error => {
        error.isGeneric = false;
        //todo:: local the messages
        globalLoaderToggle();
        if (!error.response || error.response.status === 500) {
            let message = "Oops, network/server error, check your connection please try again later";
            if (error.response) {
                message = "Oops, server error, please try again later";
            }
            swal(message)
                .then(_ => {
                    document.location.reload();
                });
            error.isGeneric = true;
        }
        return Promise.reject(error);
    })
export default http;
